export const ACCEPTED_TOPICS = [
  { id: '1', name: 'Technology', slug: 'technology' },
  { id: '2', name: 'Programming', slug: 'programming' },
  { id: '3', name: 'Design', slug: 'design' },
  {
    id: '4',
    name: 'AI & Machine Learning',
    slug: 'ai-machine-learning',
    count: 24,
  },
  { id: '5', name: 'Web Development', slug: 'web-development' },
  { id: '6', name: 'Career', slug: 'career' },
  { id: '7', name: 'Productivity', slug: 'productivity' },
];

// Function to get topic by slug
export const getTopicBySlug = (slug) => {
  return ACCEPTED_TOPICS.find((topic) => topic.slug === slug);
};

// Function to get topic by name
export const getTopicByName = (name) => {
  return ACCEPTED_TOPICS.find((topic) => topic.name === name);
};
